import React, {useState} from 'react';
import Button from '@mui/material/Button';
import SigninForm from '../components/signinform';

export default function Signin(props) {
	return(
		<div className="App">
		<h1>ZenithAI Sign In</h1>
		<h3>Don't have an account? <a href="/signup">sign up</a></h3>
		<SigninForm />
	    
	    </div>
	);
}